// removed by extract-text-webpack-plugin
module.exports = {"projectItem":"ProjectCard__projectItem__2yBcN","projectLogo":"ProjectCard__projectLogo__3dGcm","projectContext":"ProjectCard__projectContext__1m-Rs","projectInfo":"ProjectCard__projectInfo__J8mqE","projectCtime":"ProjectCard__projectCtime__3PsqF"};


//////////////////
// WEBPACK FOOTER
// ./src/views/projects/projectComponents/ProjectCard.styl
// module id = 440
// module chunks = 0